/* ==========================================================================
   NEWKERS — Scroll-Einblendungen (Dawn-Edition)
   --------------------------------------------------------------------------
   Blendet .fade-up-Blöcke beim Scrollen ein. Primär per IntersectionObserver,
   zusätzlich ein gedrosselter Scroll-Fallback für Browser, in denen der
   Observer nicht zuverlässig feuert. prefers-reduced-motion wird über das
   CSS respektiert. Nav-Menü und Konfigurator-Logik liegen NICHT hier:
   Dawns Header bleibt unverändert, die Konfigurator-Logik steckt in
   nk-produkt-konfigurator.liquid.
   ========================================================================== */

(function () {
  "use strict";

  /* Guard: das Skript wird pro nk-Section eingebunden (Dawn-Muster) —
     nur die erste Einbindung darf initialisieren */
  if (window.__nkAppleInit) return;
  window.__nkAppleInit = true;

  var THRESHOLD = 0.18;

  function pending() {
    return document.querySelectorAll(".fade-up:not(.is-visible)");
  }

  function reveal(el) {
    el.classList.add("is-visible");
  }

  /* Fallback: sichtbaren Anteil per Bounding-Box prüfen (gedrosselt) */
  var ticking = false;
  function checkViewport() {
    ticking = false;
    var els = pending();
    if (!els.length) {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (visible / r.height >= THRESHOLD) reveal(el);
    });
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    /* setTimeout statt requestAnimationFrame: rAF wird in eingebetteten/
       headless Kontexten teils nie ausgeführt, 100 ms reichen fürs Reveal */
    window.setTimeout(checkViewport, 100);
  }

  function init() {
    var els = pending();
    if (!els.length) return;

    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              reveal(entry.target);
              io.unobserve(entry.target); // nur einmal animieren
            }
          });
        },
        { threshold: THRESHOLD }
      );
      els.forEach(function (el) { io.observe(el); });
    }

    /* Fallback läuft parallel — doppeltes reveal() ist idempotent */
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    checkViewport(); // Initialzustand (bereits sichtbare Blöcke)
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Theme-Editor: Section neu gerendert → Animationen neu initialisieren
  document.addEventListener("shopify:section:load", init);
})();
